module.exports = __webpack_public_path__ + "assets/images/fountain-03.1325e82c4feb50f6447a99735dca4a98.svg";